module.exports = __webpack_public_path__ + "img/1.d8845f87.webp";